export const PlaningPermissions = {
  "Deputy General Manager": [
    {
      path: "/planing/productions",
      label: "Productions",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Manager: [
    {
      path: "/planing/productions",
      label: "Productions",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Assistant Manager": [
    {
      path: "/planing/productions",
      label: "Productions",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Executive: [
    {
      path: "/planing/productions",
      label: "Productions",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Jr Executive": [
    {
      path: "/planing/productions",
      label: "Productions",
      icon: "fas fa-chevron-right me-1",
    },
  ],
};
